export default {
    Capitalized: function (value) {
        if (!value) return '';
        value = value.toString()[0].toUpperCase() + value.toString().substr(1);
        return value;
    }
}